import { useState, useEffect, useCallback } from "react"
import { useLocation } from 'react-router';
import CasinoHeading from "../../casinoComponents/casinoHeading"
import BetTableDoliDana from "../../casinoComponents/betTableDoliDana"
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { getCasinoGameDetails, getMyBets } from "../../../apiservices/CasionApi"
import MyBet from "../../casinoComponents/myBet";
import ViewMoreModal from "../../../components/ViewMoreModal";
import ResultDoliDana from "../resultui/resultDoliDana/ResultDoliDana";
import PlaceBet from "../../casinoComponents/placeBet/NoBet";
import { extractCasinoGame } from "../../../utils/casinoGame";
import RefVideo from "../sicbo/RefVideo";

// Reference .casino-video-cards: the two dice of the current round (static/front/img/dolidana)
const DOLI_DICE = `${import.meta.env.BASE_URL}img/dolidana`;

function DoliDanaCards({ card }) {
  const cards = card ? String(card).split(",") : [];
  if (!cards[0]) return null;
  return (
    <div className="casino-video-cards">
      <div className="casino-video-cards-container">
        <div>
          <span>
            <img src={`${DOLI_DICE}/dice${cards[0]}.png`} /> <img src={`${DOLI_DICE}/dice${cards[1]}.png`} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default function DoliDana() {
  const [gameData, setGameData] = useState([])

  const [betValue, setBetValue] = useState("")
  const [showPlaceBet, setShowPlaceBet] = useState(false);
  const [iframeSrc, setiframesrc] = useState("")
  const [tableData, setTableData] = useState([]);
  const [selection, setSelection] = useState("");
  const [selectedBetData, setSelectedBetData] = useState(null);
  const [betType, setBetType] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  let { pathname } = useLocation();

  useEffect(() => {
    let name = extractCasinoGame(pathname)
    setiframesrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`)
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails("dolidana"); // Assuming type is dolidana
        setGameData(response);
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [pathname]);

  useEffect(() => {
    if (gameData) {
      const subData = gameData?.data?.data?.sub || gameData?.data?.sub || [];
      const mappedData = subData.map((item) => ({
        ...item,
        nat: item.nat,
        gstatus: item.gstatus || "OPEN",
        mid: item.mid,
        sr: item.sr,
      }));
      // Sort by sr if available
      const sortedData = mappedData.sort((a, b) => (a.sr || 0) - (b.sr || 0));
      setTableData(sortedData);
    }
  }, [gameData]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null,
            selection: bet.selection || bet.player_name || "",
            exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
          }));
          setMyBets(formattedBets);

          // Map exposure from myBets to exposures object
          const exposureMap = {};
          response.bets.forEach((bet) => {
            const selection = bet.selection || bet.player_name || "";
            const exposureAmount = parseFloat(bet.exposer || bet.exposure_amount || "0") || 0;
            if (selection) {
              exposureMap[selection] = exposureAmount;
              exposureMap[selection.toLowerCase().trim()] = exposureAmount;
              exposureMap[selection.trim()] = exposureAmount;
              exposureMap[selection.toLowerCase()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  useEffect(() => {
    if (gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid) {
      fetchMyBetsData();
      const exposureInterval = setInterval(() => {
        fetchMyBetsData();
      }, 2000);
      return () => clearInterval(exposureInterval);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid, fetchMyBetsData]);

  const handleBetClick = (value, sel, item, type = "back") => {
    if (!value) return;
    setBetValue(value)
    setSelection(item?.nat || sel)
    setSelectedBetData(item)
    setBetType(type)
    setShowPlaceBet(true)
  }

  const handleBetPlaced = () => {
    setShowPlaceBet(false);
    setBetValue("");
    setSelection("");
    setSelectedBetData(null);
    setBetType("");
    fetchMyBetsData();
  };



  const placedBetCount = myBets.length;
  const roundId = gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || "000000";
  const gameId = roundId?.toString() || "000000";
  const gameName = extractCasinoGame(pathname) || "dolidana";
  const playerNameForApi = selection;

  const feed = gameData?.data?.data ?? {};
  // Reference header: "Round ID: {sub[2].mid}" (the fancy markets' sub-round)
  const subRoundId = feed?.sub?.[2]?.mid ?? "";

  return (
    <CasinoTableLayout
      tableClass="doli-dana"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading
          name="Doli Dana"
          roundId={subRoundId}
          placedBetCount={placedBetCount}
          activeTab="game"
          onTabChange={() => {}}
        />{" "}
        <RefVideo
          iframeSrc={iframeSrc}
          timerValue={feed?.lt}
          rulesType="dolidana"
          cardsOverlay={<DoliDanaCards card={feed?.card} />}
        />{" "}
        {/* Reference renders .casino-detail once the feed has a round (casinoData.mid) */}
        {feed?.mid ? (
          <div className="casino-detail">
            <BetTableDoliDana data={tableData} onBetClick={handleBetClick} exposures={exposures} myBets={myBets} />{" "}
            <CasinoLastResult
              gameType="dolidana"
              viewAllLink="/admin/reports/casinoresult/dolidana"
              resultComponent={<ResultDoliDana gameType="dolidana" />}
            />
          </div>
        ) : null}
      </>
      {showPlaceBet && betValue && selectedBetData && (
        <PlaceBet
          betValue={betValue}
          playerName={selection}
          playerNameForApi={playerNameForApi}
          setShowPlaceBet={setShowPlaceBet}
          gameId={gameId}
          gameName={gameName}
          roundId={roundId}
          selection={selection}
          betData={selectedBetData}
          betType={betType}
          onBetPlaced={handleBetPlaced}
        />
      )}
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey="dolidana"
      />
    </CasinoTableLayout>
  )
}
